// FIXME: ロケールごとに表示する通貨を定義し、表記するための機能(V4対応で追加)
//  - そのため、動的に通貨を変更できる場所では使用不可
//  - CLIPサービスでの価格表記が統一されたらそれに合わせる。(それまではこのまま)
export default new (class LocalePrice {
  getPrice(locale: string, price: number) {
    if (locale === "ja-jp") {
      return Intl.NumberFormat("ja-JP").format(price) + "円";
    }
    if (locale === "en-us") {
      return (
        "$" +
        Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(price)
      );
    }
    if (locale === "fr-fr") {
      return (
        "€" +
        Intl.NumberFormat("fr-FR", { minimumFractionDigits: 2 }).format(price)
      );
    }
    if (locale === "de-de") {
      return (
        "€" +
        Intl.NumberFormat("de-DE", { minimumFractionDigits: 2 }).format(price)
      );
    }
    if (locale === "es-es") {
      // es-esが 'fr-FR' になっている理由は @see https://celsys.gyazo.com/0cdfed47a18c4496f114a15d385c5b56
      return (
        "€" +
        Intl.NumberFormat("fr-FR", { minimumFractionDigits: 2 }).format(price)
      );
    }
    if (locale === "ko-kr") {
      return "₩" + Intl.NumberFormat("ko-KR").format(price);
    }
    if (locale === "zh-tw") {
      return (
        "NT$" +
        Intl.NumberFormat("zh-TW", { minimumFractionDigits: 2 }).format(price)
      );
    }
    if (locale === "th-th") {
      return (
        "฿" +
        Intl.NumberFormat("th-TH", { minimumFractionDigits: 2 }).format(price)
      );
    }
    if (locale === "id-id") {
      return (
        "Rp" +
        Intl.NumberFormat("id-ID", { minimumFractionDigits: 2 }).format(price)
      );
    }
    if (locale === "pt-br") {
      return (
        "R$" +
        Intl.NumberFormat("pt-BR", { minimumFractionDigits: 2 }).format(price)
      );
    }
    if (locale === "zh-cn") {
      return (
        "$" +
        Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(price)
      );
    }
    return (
      "$" +
      Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(price)
    );
  }
})();
